module.exports = __webpack_public_path__ + "img/bb_g1_t_antenna-05.5fdf3671.svg";